import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteMedicalInformation: Map<string, ConfirmationData> = new Map([
    ["0bef57cb-d3a6-4814-b841-810b7d9836e7", { color: "skyblue", fontWeight: "bold" }],
    ["8fdf99c4-d2a2-4094-aacc-a3ec315eed11", { hidden: true }],
    ["f9009cca-6b1c-4054-835d-a4334151f0bd", { color: "skyblue", fontWeight: "bold" }],
    ["f9ac9ab2-6bd0-4ad3-87bd-15e6fdb236cb", { hidden: true }],
    ["0387b27e-db59-45c2-8f07-0bed51db67b6", { hidden: true }],
    ["a336ff23-debf-4144-85dd-5f2224e2cb10", { hidden: true }],
    ["1de4affa-0ff1-4410-a14d-0eae6ae5143e", { color: "skyblue", fontWeight: "bold" }],
    ["e65181d9-2c05-4c60-93d9-590e06ea528b", { color: "skyblue", fontWeight: "bold" }],
    ["f4439ec9-6a67-4359-80d0-b74496116985", { hidden: true }],
    ["d8581ab4-c466-4d62-a5de-1c58812cff95", { color: "skyblue", fontWeight: "bold" }],
    ["96b5c4b5-9070-4a08-b5e0-1c20702a67da", { color: "skyblue", fontWeight: "bold" }],
    ["3fa1f072-d193-4881-8c09-241bdb82931c", { color: "skyblue", fontWeight: "bold" }],
    ["8054c197-144f-447c-bef9-608549fd3bf4", { hidden: true }],
    ["b5be56e3-be06-4ab8-8988-036e5b813062", { hidden: true }],
    ["5fd458de-d6f7-42da-9529-3d675bd32fbb", { hidden: true }],
    ["09d0ff67-3a82-4022-918f-2e0a082bf6a1", { hidden: true }],
    ["64d1275e-2840-430c-a2b0-b944dcafd3a6", { color: "skyblue", fontWeight: "bold" }],
    ["ce075c38-84e7-41d1-a896-51b17fb869bf", { color: "skyblue", fontWeight: "bold" }],
    ["05913f2b-1202-420f-bccb-af85cd2c0c03", { hidden: true }],
    ["b1cdc35d-ed8d-4f27-a2ab-774eec016329", { hidden: true }],
    ["d500e184-331c-47a1-a6b9-67b84d6fcb68", { hidden: true }],
    ["fe6d12a8-e7e0-44fe-a550-bdb49b8cd582", { color: "skyblue", fontWeight: "bold" }],
    ["9ce269cb-3299-45dc-8ed5-810beab44b98", { hidden: true }],
    ["ba770d0c-66ee-4333-b786-adc485659ee8", { hidden: true }],
    ["14e0152a-6e4b-49b9-8173-94817e13c93f", { color: "skyblue", fontWeight: "bold" }],
    ["cdbe7028-6043-4b79-a3e5-8d2f22851b08", { color: "skyblue", fontWeight: "bold" }],
    ["0dde9f0f-c61a-4fb8-886c-e0efc5b88963|ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt5", { hidden: true }],
    ["f198d6f1-cd56-49c0-bc27-bdd60bb5cda4", { hidden: true }],
    ["48adefd9-3ebd-4422-a163-04f0d809e305|266cb0ed-4d3c-4b0e-b75f-098d9f00ce8c-opt5", { hidden: true }],
    ["96d3ae71-ba71-4ba9-aa68-4087cb3d84c6", { hidden: true }],
]);

